import classnames from 'classnames/bind'
import mapSliceTypeToComponent from '~/imports/legals_page'

import Link from '~/components/Link'
import RichText from '~/components/RichText'
import SliceManager from '~/components/SliceManager'

import { useStyle } from '~/providers/StyleProvider'

import getLegalsPageStaticPropsFunction from '~/data/legals-page/'
import { LegalsPageProps } from '~/data/legals-page/serializer'
import { getStaticPathsFunction } from '~/data/page-data'

import css from './styles.module.scss'

const cx = classnames.bind(css)

function Legals({ legalsPage, legalsMenu, slices }: LegalsPageProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({ textPreset: 'title-page' })
  const linkStyle = useStyle({ textPreset: 'title-section' })
  const textStyle = useStyle({ textPreset: 'rich-text-variant-1' })
  const helpStyle = useStyle({ textPreset: 'text-paragraph' })

  return (
    <div className={css.LegalsPage}>
      <div className={cx(gridStyle, css.grid)}>
        <div className={css.menu}>
          <div className={css.menuContent}>
            {legalsPage?.title && (
              <RichText className={titleStyle} render={legalsPage.title} />
            )}
            <div className={css.links}>
              {legalsMenu?.items?.map(
                ({ active, ...rest }, index) =>
                  rest && (
                    <Link
                      key={`menu_links_${index}`}
                      className={cx(css.link, linkStyle, { active })}
                      {...rest}
                    />
                  ),
              )}
            </div>
            {legalsMenu?.help && (
              <RichText
                className={cx(helpStyle, css.help)}
                render={legalsMenu.help}
              />
            )}
          </div>
        </div>

        <div className={css.separator} />
        <div className={css.mobileSeparator} />

        {legalsPage?.text && (
          <RichText
            className={cx(css.text, textStyle)}
            render={legalsPage.text}
          />
        )}
      </div>
    </div>
  )
}

export default Legals

export const getStaticProps = getLegalsPageStaticPropsFunction()
export const getStaticPaths = getStaticPathsFunction({ type: 'legals_page' })
